export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpenEprofileImplantatum');
    },
    closeForm({commit}) {
        commit('setFormCloseEprofileImplantatum');
    }
}
